import React from 'react';
import Questionnaire from './Questionnaire';

const App = () => {
  return (
    <div className="App container" style={{ fontFamily: "Arial, sans-serif" }}>
      <header className="header">
        <img width="450px" src="./logo.jpg" alt="ALTA TRAINING" />
        <title>Representational System Preference Test</title>
      </header>
      <main>
        <Questionnaire />
      </main>
    </div>
  );
};

export default App;
